module.exports = __webpack_public_path__ + "img/p9.aba21b54.png";